import { useQuery } from '@tanstack/react-query';

import { ensureAgentHubBrands } from '~/consts/agentHub';

import useCurrentBrand from '~/hooks/useCurrentBrand';

import { listUsers } from '~/services/AgentHub/AgentService';

import { ListUserParams } from '~/types/services/agentHub';

export const agentHubUsersQueryKeys = {
  all: ['agent-hub-users'] as const,
  lists: () => [...agentHubUsersQueryKeys.all, 'list'] as const,
  list: (params: ListUserParams) => [...agentHubUsersQueryKeys.lists(), params] as const,
};

interface UseListAgentHubUsersOptions {
  enabled?: boolean;
}

const FIVE_MINUTES = 5 * 60 * 1000;

export function useListAgentHubUsers(params: ListUserParams, options: UseListAgentHubUsersOptions = {}) {
  const { enabled = true } = options;
  const brand = useCurrentBrand();

  return useQuery({
    placeholderData: (prev) => ({
      rows: prev?.rows ?? [],
      total: prev?.total ?? 0,
    }),
    queryKey: agentHubUsersQueryKeys.list({ ...params, brand: ensureAgentHubBrands(brand) }),
    queryFn: async () => {
      return await listUsers({ ...params, brand: ensureAgentHubBrands(brand) });
    },
    enabled,
    staleTime: FIVE_MINUTES,
  });
}
